import { useQuery } from "react-query";
import { getTypes } from "../api/getTypes";
import { IOfficeAppliancesType } from "../types";

export default function useGetType() {
  const { data, refetch } = useQuery<IOfficeAppliancesType[]>(
    ["GetTypes"],
    getTypes,
    { refetchOnWindowFocus: false }
  );


  return { data, refetch };
}
